import React, { useState, useEffect, useRef } from 'react';
import * as S from './styles';

const InputTime = React.forwardRef(
  (
    {
      name,
      value,
      placeholder = 'HH:MM',
      label,
      error,
      disabled = false,
      onChange,
      styleContainer,
      required = true,
      ...rest
    },
    ref,
  ) => {
    const [displayValue, setDisplayValue] = useState('');
    const inputRef = useRef(null);

    // Converter minutos para formato HH:MM
    const minutesToTimeString = minutes => {
      if (!minutes || minutes === 0) return '';
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
    };

    useEffect(() => {
      if (value !== undefined && value !== null) {
        setDisplayValue(minutesToTimeString(value));
      } else {
        setDisplayValue('');
      }
    }, [value]);

    const handleInputChange = e => {
      if (disabled) return;

      let inputValue = e.target.value;

      inputValue = inputValue.replace(/[^\d:]/g, '');

      if (inputValue.length <= 5) {
        if (inputValue.length === 2 && !inputValue.includes(':')) {
          inputValue += ':';
        }

        setDisplayValue(inputValue);

        if (inputValue.match(/^\d{1,2}:\d{2}$/)) {
          const [hours, minutes] = inputValue.split(':').map(Number);

          if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
            const totalMinutes = hours * 60 + minutes;
            if (onChange) {
              onChange(totalMinutes);
            }
          }
        } else if (inputValue === '') {
          if (onChange) {
            onChange(0);
          }
        }
      }
    };

    const handleBlur = () => {
      if (disabled) return;

      if (displayValue) {
        const match = displayValue.match(/^(\d{1,2}):?(\d{0,2})$/);
        if (match) {
          const hours = parseInt(match[1] || '0', 10);
          const minutes = parseInt(match[2] || '0', 10);

          if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
            const formattedValue = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
              2,
              '0',
            )}`;
            setDisplayValue(formattedValue);

            const totalMinutes = hours * 60 + minutes;
            if (onChange) {
              onChange(totalMinutes);
            }
          } else {
            setDisplayValue('');
            if (onChange) {
              onChange(0);
            }
          }
        } else {
          setDisplayValue('');
          if (onChange) {
            onChange(0);
          }
        }
      }
    };

    const handleKeyDown = e => {
      if (
        ![8, 9, 27, 13, 46, 110, 190].includes(e.keyCode) &&
        (e.keyCode < 48 || e.keyCode > 57) &&
        (e.keyCode < 96 || e.keyCode > 105) &&
        e.keyCode !== 186 &&
        e.keyCode !== 59
      ) {
        e.preventDefault();
      }
    };

    return (
      <S.InputTime disabled={disabled} style={styleContainer}>
        {label && <S.Label htmlFor={name}>{label}</S.Label>}

        <S.InputContainer>
          <S.Input
            ref={inputRef}
            id={name}
            name={name}
            value={displayValue}
            type="text"
            placeholder={placeholder}
            disabled={disabled}
            onChange={handleInputChange}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            maxLength="5"
            required={required}
            {...rest}
          />

          {error && <S.Error>{error}</S.Error>}
        </S.InputContainer>
      </S.InputTime>
    );
  },
);

InputTime.displayName = 'InputTime';

export default InputTime;
